import { implementaValorEnTodosLosFormu } from "./implementaValorEnTodosLosFormu";
import { handleTestJourney } from "../handleTestJourney";
import { handleFormularioSegunDatalayer } from "./handleFormularioSegunDatalayer";
import { activarSubmitBtn, desActivarBTNSubmit } from "./handleBtn";
import { handleCheckboxChange } from "./handleCheckboxChange";

var ActivadorBTN;

function handleClickBtnDeshabilitado() {
    for (let index = 0; index < ActivadorBTN.length; index++) {
        if (ActivadorBTN[index].value != true) {

            const inpuntElement = document.getElementsByName(`${ActivadorBTN[index].nombre}`);
            const errorTexts = document.getElementsByClassName(`error__${ActivadorBTN[index].nombre.toLowerCase()}`);

            for (let indexErrText = 0; indexErrText < errorTexts.length; indexErrText++) {

                errorTexts[indexErrText].style.display = "block";

                errorTexts[indexErrText].innerHTML === "" ?
                    ActivadorBTN[index].nombre != "Compañía_actual" ?
                        errorTexts[indexErrText].innerHTML = "El campo es obligatorio" :
                        errorTexts[indexErrText].innerHTML = "Selecciona una opción" :
                    errorTexts[indexErrText].innerHTML = errorTexts[indexErrText].innerHTML;

                inpuntElement[indexErrText].classList.add("form-control-error");

            }
        }
    }
}

function validarBtn() {
    let element = ActivadorBTN.find(element => element.value == false)

    if (element == undefined || element == "undefined") {
        activarSubmitBtn();
    } else {
        desActivarBTNSubmit();
    }
}

function clickBotonDeshabilitado() {
    const observer = new MutationObserver(() => {
        const btnInactivo = document.getElementsByClassName("btn_in_activo");

        if (btnInactivo.length > 0) {
            const btnInactivo = document.getElementsByClassName("btn_in_activo");

            for (let index = 0; index < btnInactivo.length; index++) {
                btnInactivo[index].addEventListener("click", handleClickBtnDeshabilitado);
                btnInactivo[index].addEventListener("touchstart", handleClickBtnDeshabilitado);
            }

            // Detener la observación después de encontrar el elemento
            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

function gestionarCliente(inputContainer) {

    // Cuadrado rosa que informa para que se utiliza el DNI.
    // En principio siempre será el mismo numero de elementos en cada array por lo que utilizaremos el mismo bucle para lo mismo.
    const container_msn_dni = document.getElementsByClassName("container_msn_dni");
    const listElementsDocument = document.getElementsByClassName("gestion_documento");
    const listInputsCp = document.getElementsByClassName("gestion_cp");
    const containerElement = document.getElementsByClassName("container_element");
    const actualizadoCP = ActivadorBTN.findIndex((elementActivador) => elementActivador.nombre.toLowerCase() === "codigo_postal");
    const actualizadoDocument = ActivadorBTN.findIndex((elementActivador) => elementActivador.nombre.toLowerCase() === "documento");
    const containerCp = document.getElementsByName("Codigo_postal");
    const containerDocumento = document.getElementsByName("Documento");

    handleTestJourney();

    for (let i = 0; i < containerElement.length; ++i) {
        containerElement[i].style.display = "block";
    }

    if (inputContainer.id.toLowerCase() == "si") {
        for (let i = 0; i < container_msn_dni.length; ++i) {
            container_msn_dni[i].style.display = "block";
        }

        // aparece DNI y desaparece codigo postal
        for (let index = 0; index < listInputsCp.length; ++index) {
            listInputsCp[index].style.display = "none";
            listInputsCp[index].childNodes[3].value = "";
            listInputsCp[index].childNodes[3].required = false;
        }

        for (let index = 0; index < listElementsDocument.length; ++index) {
            // le implementamos flex para que no rompa los estilos
            listElementsDocument[index].style.display = "grid";
        }

        if (listElementsDocument.length > 1) {
            listElementsDocument[1].childNodes[3].required = true;
            // listElementsDocument[3].childNodes[3].required = true;

            ActivadorBTN[actualizadoCP].value = true;
            ActivadorBTN[actualizadoDocument].value = false;
        }

        for (let i = 0; i < containerCp.length; ++i) {
            containerCp[i].classList.remove("form-control-success");
        }

        validarBtn();

    } else if (inputContainer.id.toLowerCase() == "no") {

        for (let i = 0; i < container_msn_dni.length; ++i) {
            container_msn_dni[i].style.display = "none";
        }

        //alreves
        for (let index = 0; index < listInputsCp.length; ++index) {
            listInputsCp[index].style.display = "grid";
            listInputsCp[index].childNodes[3].required = true;
        }

        for (let index = 0; index < listElementsDocument.length; ++index) {
            listElementsDocument[index].style.display = "none";
        }

        for (let i = 0; i < containerDocumento.length; ++i) {
            containerDocumento[i].classList.remove("form-control-success");
        }

        listElementsDocument[1].childNodes[3].value = "";
        listElementsDocument[1].childNodes[3].required = false;

        // Gestion de la validacion del boton al seleccionar NO es cliente
        ActivadorBTN[actualizadoCP].value = false;
        ActivadorBTN[actualizadoDocument].value = true;
        validarBtn();

    }

    if (inputContainer.value.toLowerCase() == "no" || inputContainer.value.toLowerCase() == "si" || inputContainer.value.toLowerCase() == true || inputContainer.value.toLowerCase() == false) {
        window.userLabels.EDeclaratives.esCliente = inputContainer.value.toLowerCase();
    } else {
        window.userLabels.EDeclaratives.esCliente = "";
    }
}

function validarDniNie(value) {

    let number, dni, letter;
    let expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;
    value = value.toUpperCase();
    if (expresion_regular_dni.test(value) === true) {
        number = value.substr(0, value.length - 1);
        number = number.replace('X', 0);
        number = number.replace('Y', 1);
        number = number.replace('Z', 2);
        dni = value.substr(value.length - 1, 1);
        number = number % 23;
        letter = 'TRWAGMYFPDXBNJZSQVHLCKET';
        letter = letter.substring(number, number + 1);

        if (letter != dni) {
            return false;

        } else {
            return true;
        }

    } else {
        return false;
    }
}

function validarNombreApellido(value) {

    let expresion_regular_nombre = /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/g;

    if (expresion_regular_nombre.test(value)) {
        return true;
    }

    return false;
}

function validarTelefono(value) {

    let expresion_regular = /^[76]{1}[0-9]{8}$/gm;

    if (expresion_regular.test(value)) {
        return true;
    }

    return false;
}

function validarEmail(value) {

    let expresion_regular_email = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (expresion_regular_email.test(value)) {
        return true;
    }

    return false;
}

function validarCp(value) {

    var numeroPostal = value;
    var expresionRegular1 = /^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/;//<--- con esto vamos a validar el numero
    var expresionRegular2 = /\s/;//<--- con esto vamos a validar que no tenga espacios en blanco
    var provincias = ["ARABA/ALAVA", "Albacete", "Alicante", "Almeria", "Avila", "Badajoz", "Baleares", "Barcelona", "Burgos", "Caceres", "Cadiz", "Castellon", "Ciudad Real", "Cordoba", "Coruña", "Cuenca", "Gerona", "Granada", "Guadalajara", "Guipuzcoa", "Huelva", "Huesca", "Jaen", "Leon", "Lerida", "La Rioja", "Lugo", "Madrid", "Malaga", "Murcia", "Navarra", "Orense", "Asturias", "Palencia", "Las Palmas", "Pontevedra", "Salamanca", "Santa Cruz De Tenerife", "Cantabria", "Segovia", "Sevilla", "Soria", "Tarragona", "Teruel", "Toledo", "Valencia", "Valladolid", "BIZKAIA", "Zamora", "Zaragoza", "Ceuta", "Melilla"]

    if (numeroPostal === '') {
        return false;
    } else if (expresionRegular2.test(numeroPostal)) {
        return false;
    } else if (!expresionRegular1.test(numeroPostal)) {
        return false;
    } else {
        var codigoProvincia = parseInt(numeroPostal.substring(0, 2)) - 1;
        if (codigoProvincia < 52) {
            // $('#Provincia, #Provincia1, #Provincia2').val(provincias[codigoProvincia]); // Eliminar esta línea al remover jQuery
            var provinciasIds = ["Provincia", "Provincia1", "Provincia2"];
            provinciasIds.forEach(function (id) {
                var element = document.getElementById(id);
                if (element) {
                    element.value = provincias[codigoProvincia];
                }
            });
            return true;

        } else {
            // $('#Provincia, #Provincia1, #Provincia2').val("Madrid"); // Eliminar esta línea al remover jQuery
            var provinciasIds = ["Provincia", "Provincia1", "Provincia2"];
            provinciasIds.forEach(function (id) {
                var element = document.getElementById(id);
                if (element) {
                    element.value = "Madrid";
                }
            });
            return false;
        }
    }
}

function gestionarNoCampaña(value) {

    if (value === '') return false;

    const options = document.getElementsByClassName('compania_options')[0].options;
    const totalOptions = options.length;
    let identica = false;

    let inputValue = value.toLowerCase();
    let totalMostrar = 0;

    for (let i = 0; i < options.length; i++) {
        let optionText = options[i].text.toLowerCase();
        let optionValue = options[i].value.toLowerCase();


        if (!optionText.includes(inputValue) || !optionValue.includes(inputValue)) {
            totalMostrar++;
        }

        if (optionText === inputValue) {
            identica = true
        }

    }

    const actualizado = ActivadorBTN.findIndex((elementActivador) => elementActivador.nombre.toLowerCase() === "vencimiento");

    if (totalOptions === totalMostrar) {
        return false;
    } else if (!identica) {
        return false;
    } else {

        ActivadorBTN[actualizado].value = false;
        return true;
    }

}

function validarVencimiento(element) {
    const fechaActual = new Date();
    const fechaSeleccionada = new Date(element.value);

    const diff = fechaSeleccionada - fechaActual;
    const dias = Math.trunc(diff / (1000 * 60 * 60 * 24));

    if (dias >= 0 && dias <= 120) {
        return true
    };

    return false;
}

function validarJubilacion(element) {
    const fechaActual = new Date();
    const fechaSeleccionada = new Date(element.value);

    const diff = fechaActual - fechaSeleccionada;
    const anhio = Math.trunc(diff / (1000 * 60 * 60 * 24 * 365));

    if (anhio >= 65) {
        return true
    };

    return false;
}

function validarNacimiento(element) {
    const fechaActual = new Date();
    const fechaSeleccionada = new Date(element.value);

    const diff = fechaActual - fechaSeleccionada;
    const anhio = Math.trunc(diff / (1000 * 60 * 60 * 24 * 365));

    if (anhio >= 18) {
        return true
    };

    return false;
}

//Funcion encargada de dar los estilos a los input según la validez de los datos implementados.
//Recibe como argumento el elemento y un buleano que valida el dato.
function validarInput(elemento, datoValidado) {

    const actualizado = ActivadorBTN.findIndex((elementActivador) => elementActivador.nombre.toLowerCase() === elemento.name.toLowerCase());
    const errorTexts = document.getElementsByClassName(`error__${elemento.name.toLowerCase()}`);

    if (!datoValidado) {
        elemento.classList.remove("form-control-success");
        elemento.classList.add("form-control-error");

        for (let indexErrText = 0; indexErrText < errorTexts.length; indexErrText++) {
            errorTexts[indexErrText].style.display = "block";
            errorTexts[indexErrText].innerHTML = ActivadorBTN[actualizado].errorText;
        }

        ActivadorBTN[actualizado].value = false;
    } else {
        elemento.classList.remove("form-control-error");
        elemento.classList.add("form-control-success");

        for (let indexErrText = 0; indexErrText < errorTexts.length; indexErrText++) {
            errorTexts[indexErrText].style.display = "none";
            errorTexts[indexErrText].innerHTML = "";
        }

        ActivadorBTN[actualizado].value = true;
    }

    validarBtn();
    implementaValorEnTodosLosFormu(elemento);
}

function eventosDeValidacion(inputContainer) {

    inputContainer.addEventListener("input", function (event) {

        switch (inputContainer.name.toLowerCase()) {
            case "documento":
                validarDniNie(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            case "telefono":
                validarTelefono(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            case "email":
                validarEmail(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            case "nombre":
                validarNombreApellido(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            case "apellidos":
                validarNombreApellido(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            case "codigo_postal":
                validarCp(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            case "compañía_actual":
                gestionarNoCampaña(event.target.value) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            case "vencimiento":
                validarVencimiento(event.target) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            case "jubilacion":
                validarJubilacion(event.target) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            case "ano_nacimiento":
                validarNacimiento(event.target) ?
                    validarInput(inputContainer, true) :
                    validarInput(inputContainer, false);
                break;

            default:
                break;
        }

        validarBtn();

    });
}

// observa los elementos seleccionados y actua segun el elemento introducido
export function validacion(objActivador) {
    ActivadorBTN = objActivador;
    validarBtn();
    clickBotonDeshabilitado();
    handleFormularioSegunDatalayer();
    handleCheckboxChange();

    document.addEventListener('click', handleValidator);
    document.addEventListener('touchstart', handleValidator);
    document.addEventListener('keydown', handleValidator);

    //Solo con este no salta el error en consola
    // document.addEventListener('change', handleValidator);

    function handleValidator(event) {
        const inputElement = event.target;

        // Para validar el input el nombre tiene que estar en esta lista y el validador en el switch
        const inputListElements = ["Telefono", "Codigo_postal", "Documento", "email", "Nombre", "Apellidos", "Compañía_actual", "Vencimiento", "Jubilacion", "ano_nacimiento"];

        if (inputElement.type === 'radio') {
            gestionarCliente(inputElement);
        }

        let isOk = inputListElements.includes(inputElement.name);
        if (isOk) {
            inputElement.autocomplete = "off";

            if (inputElement.name === "Vencimiento") {
                inputElement.min = new Date();
                inputElement.max = "9999-12-31";
            }

            eventosDeValidacion(inputElement);
        }

    };
}